import _toConsumableArray from "/home/patrick/jamespatrickleduc.github.io/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function clone(p) {
  return _toConsumableArray(p);
}

export function curveToBezier(pointsIn) {
  var curveTightness = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var len = pointsIn.length;

  if (len < 3) {
    throw new Error('A curve must have at least three points.');
  }

  var out = [];

  if (len === 3) {
    out.push(clone(pointsIn[0]), clone(pointsIn[1]), clone(pointsIn[2]), clone(pointsIn[2]));
  } else {
    var points = [];
    points.push(pointsIn[0], pointsIn[0]);

    for (var i = 1; i < pointsIn.length; i++) {
      points.push(pointsIn[i]);

      if (i === pointsIn.length - 1) {
        points.push(pointsIn[i]);
      }
    }

    var b = [];
    var s = 1 - curveTightness;
    out.push(clone(points[0]));

    for (var _i = 1; _i + 2 < points.length; _i++) {
      var cachedVertArray = points[_i];
      b[0] = [cachedVertArray[0], cachedVertArray[1]];
      b[1] = [cachedVertArray[0] + (s * points[_i + 1][0] - s * points[_i - 1][0]) / 6, cachedVertArray[1] + (s * points[_i + 1][1] - s * points[_i - 1][1]) / 6];
      b[2] = [points[_i + 1][0] + (s * points[_i][0] - s * points[_i + 2][0]) / 6, points[_i + 1][1] + (s * points[_i][1] - s * points[_i + 2][1]) / 6];
      b[3] = [points[_i + 1][0], points[_i + 1][1]];
      out.push(b[1], b[2], b[3]);
    }
  }

  return out;
}